import { render } from "./ReleaseNoteGenerator.vue?vue&type=template&id=4ca888e2&scoped=true"
import script from "./ReleaseNoteGenerator.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteGenerator.vue?vue&type=script&lang=js"

import "./ReleaseNoteGenerator.vue?vue&type=style&index=0&id=4ca888e2&scoped=true&lang=css"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca888e2"]])

export default __exports__